export enum Event {
  Load = "load",
  Error = "error",
}
